import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { checkAndLogErrors } from '../../utils';

// PACKAGES
import { useHistory } from 'react-router';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';
import { PolicyReinstateCommand } from '../../api/models';

interface ReInstateModalTypes {
	title?: string;
	policyId?: string;
	closeModal?: closeModalType;
}

const ReInstateModal: React.FC<ReInstateModalTypes> = ({ title, policyId, closeModal }) => {
	const history = useHistory();

	const [showError, setShowError] = React.useState<boolean>(false);

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const reInstatePolicy = async () => {
		if (policyId) {
			setIsLoading(true);

			const data: PolicyReinstateCommand = { id: policyId };

			const response = await apibridge.reInstatePolicy(data);

			if (response.isError) {
				checkAndLogErrors(response);

				setIsLoading(false);

				setShowError(true);
			} else {
				setIsLoading(false);

				setShowError(false);

				if (closeModal) {
					closeModal();
				}

				history.push('/policies');
			}
		}
	};

	return (
		<div className="modal-confirmation">
			{showError ? (
				<ErrorMessage />
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to <strong>Re-instate</strong>{' '}
									<strong className="text-capitalized">'{title}'</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={reInstatePolicy}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ReInstateModal;
